import { HttpResponseError } from './HttpResponseError.js';
/**
 * Represents an error that occurs when handling a JSON response in an HTTP request.
 * Extends the base `HttpResponseError` class.
 *
 * @template TType - The type of the data associated with the error.
 * @template TResponse - The type of the HTTP response.
 */
export class HttpJsonResponseError extends HttpResponseError {
    static Name = 'HttpJsonResponseError';
    /** The parsed JSON data associated with the error response, if any. */
    data;
    /**
     * Creates a new instance of `HttpJsonResponseError`.
     *
     * @param message - The error message.
     * @param response - The HTTP response associated with the error.
     * @param options - Additional options for the error, including the associated data.
     */
    constructor(message, response, options) {
        super(message, response, options);
        this.name = HttpJsonResponseError.Name;
        this.data = options?.data;
    }
}
export default HttpJsonResponseError;
//# sourceMappingURL=HttpJsonResponseError.js.map